import { useLocation, useNavigate } from "react-router-dom";
import { Card, Button, notification, message } from "antd";
import { createUseStyles } from "react-jss";
import OutletSummary from "../../components/OutletSummary";
import { useAuth } from "../../../../uiComponent/authProvider/AuthContext";
import { useState } from "react";
import OutletService, {
  OutletServiceAction,
} from "../../../../services/outletService";

const useStyles = createUseStyles({
  container: {
    padding: "20px",
    background: "#fff",
    minHeight: "100vh",
  },
  card: {
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  details: {
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
});

export default function OutletAddReview() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { data, request } = location.state as any;
  const { loginData } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!loginData?._csrf) {
      return;
    }

    try {
      await OutletService(OutletServiceAction.ADD, request, loginData?._csrf);
      setTimeout(() => {
        notification.success({
          message: "Outlet Added",
          description: "The outlet has been successfully added.",
          placement: "topRight",
        });
        navigate("/outlet/add/success", { state: { data: data } });
      }, 1000);
    } catch (error) {
      message.error(`${error}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <h2>Outlet Add Review</h2>
        <OutletSummary data={data} />
        <div className={classes.buttonContainer}>
          <Button
            onClick={() => navigate("/outlet/add/input")}
            type="default"
            loading={loading}
          >
            Back
          </Button>
          <Button onClick={handleSubmit} type="primary" loading={loading}>
            Submit
          </Button>
        </div>
      </Card>
    </div>
  );
}
